import Vue from "vue";
import { AclCreate, AclInstaller, AclRule } from "../lib/acl";
import router from "../router";
import session from "../util/session";

Vue.use(AclInstaller);

export default new AclCreate({
    initial: "public",
    notfound: {
        path: "/tidak-ditemukan",
        forwardQueryParams: true,
    },
    router,
    acceptLocalRules: true,
    globalRules: {
        isPublic: new AclRule("public").generate(),
        isSuperAdmin: new AclRule("super_admin").generate(),
        isAdmin: new AclRule("super_admin").or("admin").generate(),
        isOnlySpitda: new AclRule("spitda").generate(),
        isKepalaSpitda: new AclRule("kepala_spitda")
            .or("super_admin")
            .or("admin")
            .generate(),
        isSpitda: new AclRule("spitda")
            .or("kepala_spitda")
            .or("super_admin")
            .or("admin")
            .generate(),
        isSwasta: new AclRule("swasta")
            .or("spitda")
            .or("super_admin")
            .or("admin")
            .generate(),
        isLogged: new AclRule("negeri")
            .or("swasta")
            .or("kepala_spitda")
            .or("admin")
            .or("spitda")
            .or("super_admin")
            .generate(),
        isSekolah: new AclRule("negeri").or("swasta").generate(),
    },
    middleware: async(acl) => {
        let cache = session.get.user();
        if (cache.groupID) acl.change(cache.groupID);
        else acl.change("public");
    },
});